import { gql } from '@apollo/client';

export const GET_USERS_V3 = gql`
  query usersV3(
    $organisation: String
    $pageNumber: Int = 0
    $pageSize: Int = 10
    $search: String = ""
  ) {
    usersV3(
      organisation: $organisation
      pageNumber: $pageNumber
      pageSize: $pageSize
      search: $search
    ) {
      users {
        name
        firstName
        lastName
        id
        uuid
        email
        enabled
        membershipsV2 {
          enabled
          organisation
          rolesWithName {
            id
            name
          }
        }
      }
      totalCount
    }
  }
`;
